import {getAxiosTotall} from "./ApiInstance"

export const getTaxiPrice =(info,call)=>{
    getAxiosTotall().post("taxi/calculate/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const requestTaxiPost =(info,call)=>{
    getAxiosTotall().post("taxi/call_taxi/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
///////// get method /////////////
export const getDriverAccepted =(callback)=>{
    getAxiosTotall().get("taxi/check_requests/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getTravelsDataApi =(callback)=>{
    getAxiosTotall().get("taxi/travels/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}